import { Checkbox } from '@onefootprint/ui';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FiltersDrawer from '@/components/filters-drawer';
import useInitialSOSFilingsFilters from '../../hooks/use-initial-sos-filings-filters';
import useSOSFilingStatesQueryParams from '../../hooks/use-sos-filings-states-query-params';
export type FormData = {
  states: string[];
};
type DrawerFilterProps = {
  states: string[];
};
const DrawerFilter = ({
  states
}: DrawerFilterProps) => {
  const {
    t
  } = useTranslation('entity-details', {
    keyPrefix: 'onboardings.registrations.filters'
  });
  const [open, setOpen] = useState(false);
  const queryParams = useSOSFilingStatesQueryParams();
  const {
    defaultValues,
    emptyValues
  } = useInitialSOSFilingsFilters();
  const {
    control,
    handleSubmit,
    reset,
    watch
  } = useForm<FormData>({
    defaultValues
  });
  const {
    hasFilters,
    filtersCount
  } = queryParams;
  const selectedStates = watch('states');
  const handleOpenChange = (nextOpen: boolean) => {
    reset(defaultValues);
    setOpen(nextOpen);
  };
  const onSubmit = (formData: FormData) => {
    queryParams.push({
      filingsStates: [...formData.states]
    });
    handleOpenChange(false);
  };
  const handleReset = () => {
    reset(emptyValues);
    queryParams.push({
      filingsStates: undefined
    });
    handleOpenChange(false);
  };
  return <FiltersDrawer count={hasFilters ? filtersCount : 0} open={open} onOpenChange={handleOpenChange} onApply={handleSubmit(onSubmit)} onClear={handleReset}>
      <form className="flex flex-col w-full" onSubmit={handleSubmit(onSubmit)}>
        <FiltersDrawer.Section title={t($ => $.states.label)} count={selectedStates.length} defaultOpen>
          <Controller control={control} name="states" render={({
          field
        }) => <FiltersDrawer.SearchList items={states} getSearchText={state => state} placeholder={t($_0 => $_0.states.searchPlaceholder)} emptyText={t($_1 => $_1.states.empty)} renderItem={state_0 => <Checkbox key={state_0} label={state_0} checked={field.value.includes(state_0)} onChange={() => field.onChange(field.value.includes(state_0) ? field.value.filter(value => value !== state_0) : [...field.value, state_0])} />} />} />
        </FiltersDrawer.Section>
      </form>
    </FiltersDrawer>;
};
export default DrawerFilter;